import { RootState, useAppDispatch, useAppSelector } from '../../store/store';
import {  DeleteTrainingDataset, handleToggleDeleteFilePopup } from '../../store/mlcreator-slice/mlcreator';
import { useTranslation } from 'react-i18next';
import { enqueueSnackbar } from '../../store/app-slice/app';
import { handleNotificationVariant } from '../notifications/_common';
import DeleteDialog from '../common/DeleteDialog';
  
interface DeleteFilePopupProps {
    onDeleteSuccess?: () => void;
}

const DeleteFilePopup = (props: DeleteFilePopupProps) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const { deletingFile, deleteFilePopupOpen, deleteFileBodyParams } = useAppSelector((state: RootState) => state.mlcreator);
  
    function handleClose() {
        dispatch(handleToggleDeleteFilePopup({ open: false, body: null }));
    }
  
    function handleSubmit() {
        dispatch(DeleteTrainingDataset(deleteFileBodyParams.fileId)).then((res : any) => {
                if(res && res.payload) { 
                    dispatch(enqueueSnackbar({ 
                        message: t(`${res.payload.message}`),
                        options: { 
                            variant: handleNotificationVariant(res.payload.success),
                            persist: !res.payload.success
                        } 
                    }))
                    if (res.payload.success && props.onDeleteSuccess) {
                        props.onDeleteSuccess()
                    }
                }
            }
        );
    }
  
    if(!deleteFileBodyParams) return <></>;

    return(
        <DeleteDialog
            open={deleteFilePopupOpen} 
            title={t('DELETE_FILE_TITLE', { fileName: deleteFileBodyParams.fileName })} 
            bodyText={t('DELETE_FILE_BODY')} 
            isLoading={deletingFile} 
            onClose={function (reason?: string): void {
                handleClose();
            }} 
            onSubmit={function (): void {
                handleSubmit();
            }} 
            cancelButtonText={t('CANCEL_BUTTON')} 
            submitButtonText={t('SUBMIT_BUTTON')}
        />
    )
}

export default DeleteFilePopup;